import { Box, Center, Stack, Text } from "@chakra-ui/layout";

import { Heading } from "@chakra-ui/react";
import Tweets from "components/tweets";
import React, { useEffect } from "react";
import { getPlan, useCredit } from "controllers/subscription";

import { useSession } from "next-auth/react";

import ProtectedRoute from "components/protected-route";

import { useRouter } from "next/dist/client/router";
import toast from "react-hot-toast";
import PuffLoader from "react-spinners/PuffLoader";
import { MainContext } from "../../context/mainContext";
import { useMiscellaneousContext } from "context/miscellaneousContext";
import { formatGenerateResponse, search } from "../../controllers/search";
import { getAccount } from "../../utils/sessionHelper";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { useInterval } from "../../utils/useInterval";
import { textStyle } from "theme/names";
import { CustomToast } from "components/toasts/CustomToast";
import { UpgradePopup } from "components/upgrade-popup";

import { getCachedKey, getCachedKeyTime, updateCachedKey, updateCachedKeyTime } from "../../utils/localforageHelpers";

export interface AiSuggestionsProps {
  suggestionsCount?: number;
  maxWidth?: string;
  numCols?: number;
  showOriginals?: boolean;
  dense?: boolean;
  setIsLoading?: (isSeeding: boolean) => void
}


export const AiSuggestions = ({ suggestionsCount = 6, setIsLoading, showOriginals = true, dense = false }: AiSuggestionsProps) => {
  const { data: session, status } = useSession() ?? {};
  const loading = status === "loading";

  const [savedTweet, setSavedTweet] = React.useState([]);
  const [isSending, setIsSending] = React.useState(false);
  const [data, setData] = React.useState<any>(null);
  const router = useRouter();

  const setLoadingState = (isLoading: boolean) => {
    setIsSending(isLoading);
    if (setIsLoading) {
      setIsLoading(isLoading);
    }
  }

  const [refresh, refresher] = React.useState({});
  const [hasFetched, setHasFetched] = React.useState(false);
  const isAuthenticated = useFirebaseUser();
  const mainContext = React.useContext(MainContext);
  const [cachedPostsLoaded, setCachedPostsLoaded] = React.useState(false);
  const isRefreshedClicked = React.useRef(false);

  const [pourcent, setPourcent] = React.useState(0);

  const miscellaneousContext: any = useMiscellaneousContext();

  const plan = getPlan(session?.user);
  const isStarterPlan = plan === "start";

  useEffect(() => {
    if (
      session?.user?.data?.id &&
      isAuthenticated &&
      !hasFetched &&
      !isStarterPlan
    ) {
      getTweets(session);
      setHasFetched(true);
    }
  }, [session, isAuthenticated]);

  const resetLoader = () => {
    setPourcent(0);
  };

  useInterval(() => {
    if (pourcent < 95) {
      let inc = Math.round(Math.random() * 2);
      setPourcent(pourcent + inc);
    }
  }, 500);


  const refreshClickedCallback = () => {
    setLoadingState(false);
    isRefreshedClicked.current = true;
  };

  // const sendRequest = React.useCallback(async (session, topic) => {
  const getTweets = async (session) => {
    try {
      if (isStarterPlan) {
        return;
      }

      console.log("getTweets");
      // if (! await useCredit(session, mainContext))
      // return;
      let useBestAi = await useCredit(
        session,
        mainContext,
        "creditsBestai",
        false
      );

      if (isSending && !(isRefreshedClicked.current === true)) return;

      if (!getAccount(session)?.keywords?.join) {
        // console.log("error keywords");
        toast.error("Error with your parameters");
        router.push("/onboarding");
        return;
      }

      setLoadingState(true);
      miscellaneousContext.setIsDataRefreshing(true);
      resetLoader();

      const cachedPosts: any = (await getCachedKey("cachedSuggestedPosts")) ?? ({} as any);
      const cachedPostsTime = (await getCachedKeyTime("cachedSuggestedPostsTime")) ?? 0;
      const aDayFromNow = new Date().getTime() + 24 * 60 * 60 * 1000;

      if (Boolean(cachedPostsTime) === false) {
        await updateCachedKeyTime("cachedSuggestedPostsTime", aDayFromNow);
      }

      if (
        new Date().getTime() <= new Date(cachedPostsTime).getTime() &&
        !isRefreshedClicked.current
      ) {
        if (Boolean(cachedPosts) === true && cachedPosts?.tweets?.length > 0) {
          console.log("cache hit");
          if (cachedPosts?.tweets?.length > suggestionsCount) {
            setData({ ...cachedPosts, tweets: cachedPosts.tweets.slice(0, suggestionsCount) });
          } else {
            setData({ ...cachedPosts });
          }
          setCachedPostsLoaded(true);
          setHasFetched(true);
          setLoadingState(false);
          miscellaneousContext.setIsDataRefreshing(false);
          return;
        } else {
          console.log("cache miss");
          setCachedPostsLoaded(false);
        }
      }

      if (!cachedPostsLoaded || isRefreshedClicked.current === true) {
        console.log("caching...");
        let params = {
          isPersonalizedSorting: true,
          useBestAi,
          nbMinDaysOld: 30,
          nbMaxDaysOld: 1000,
          nbMinLikes: 100,
          noHashtag: true,
          noDollar: true,
          countToGenerate: suggestionsCount,
          count: 100,
          twUserName: getAccount(session).username,
          username: getAccount(session)?.username,
          keywords: getAccount(session)?.keywords?.join(","),
          description: getAccount(session)?.description,
        };

        // start toast custom
        const toastIdCustom = toast.loading(
          <CustomToast useCreditBoolean={useBestAi} />
        );

        //@ts-ignore
        let data = await search(
          session,
          getAccount(session).keywords.join(","),
          params,
          "generateFromListTaplio",
          mainContext
        );

        if (data && data.success) {
          formatGenerateResponse(data, session);
          setData({ ...data });
          await updateCachedKey("cachedSuggestedPosts", data);
          await updateCachedKeyTime("cachedSuggestedPostsTime", aDayFromNow);
        }
        setHasFetched(true);
        setLoadingState(false);
        setCachedPostsLoaded(false);
        isRefreshedClicked.current = false;
        miscellaneousContext.setIsDataRefreshing(false);
        // end toast custom
        toast.dismiss(toastIdCustom);
      }
    } catch (e) {
      console.log("Error in getTweets: " + e.message, e);
    }
  };

  if (!loading && !session) {
    return <ProtectedRoute />;
  }

  return (
    <>
      {isStarterPlan ? (
        <UpgradePopup
          currentPlan={plan}
          feature="Post Generator Features"
          availablePlans={["grow", "enterprise"]}
        />
      ) : (
        <Stack>
          {isSending && !isRefreshedClicked.current ? (
            <Center pt={20} flexDirection="column">
              <PuffLoader
                color={"#0A66C2"}
                loading={isSending}
                cssOverride={{
                  display: "block",
                  margin: "0 auto",
                  borderColor: "red",
                }}
                size={50}
              />
              <Text
                textStyle={textStyle["body.medium.light"]}
                mt={5}
                pl={2}
                fontSize={"sm"}
                fontWeight="600"
              >
                {pourcent + "%"}
              </Text>
            </Center>
          ) : //@ts-ignore
            (!isSending || isRefreshedClicked.current) && data?.tweets?.length ? (
              <Box>
                <Tweets
                  //@ts-ignore
                  sendRequest={getTweets}
                  //@ts-ignore
                  tweets={data.tweets}
                  //@ts-ignore
                  data={data}
                  //@ts-ignore
                  setData={setData}
                  disableBlur={true}
                  disableBookmarkButton={true}
                  refresher={refresher}
                  refresh={refresh}
                  disableSaveCsv={dense}
                  disableEmbed={true}
                  disableTryAgain={true}
                  disableHideButton={true}
                  disableRequest={true}
                  disableSubMenu={true}
                  disableName={false}
                  isVariation={true}
                  disableAddToQueue={false}
                  disableTweetSelection={true}
                  disableRefresh={dense}
                  disableSettings={true}
                  isExportButtonSecondary={true}
                  refreshClickedCallback={refreshClickedCallback}
                  maxWidth={dense ? '100%' : undefined}
                  numCols={dense ? 3 : undefined}
                  // disableHideGeneration={false}
                  source="suggested"
                />
              </Box>
            ) : (
              <Box>
                <Center m={10} flexDirection="column">
                  <Text textStyle={textStyle["body.medium.light"]} m={5}>
                    Nothing yet
                  </Text>
                  <Text textStyle={textStyle["body.medium.light"]}>
                    Robots are currenty writing content for you...
                  </Text>
                </Center>
              </Box>
            )}
          {
            //@ts-ignore
            !isSending &&
            showOriginals &&
            data?.originals?.length &&
            (session?.user?.data?.isAdmin ||
              !process.env.NODE_ENV ||
              process.env.NODE_ENV == "development") && (
              <Box>
                <Heading m={5} fontSize="lg">
                  Tweets picked to generate new ones (admin only)
                </Heading>
                <Tweets
                  //@ts-ignore
                  sendRequest={getTweets}
                  savedTweet={savedTweet}
                  //@ts-ignore
                  tweets={data.originals}
                  //@ts-ignore
                  data={data}
                  //@ts-ignore
                  setData={setData}
                  disableBookmarkButton={false}
                  refresher={refresher}
                  refresh={refresh}
                  disableSaveCsv={true}
                  disableEmbed={true}
                  disableTryAgain={false}
                  source="ez4cast"
                  disableBlur={true}
                />
              </Box>
            )
          }
        </Stack>
      )}
    </>
  );
};

export default AiSuggestions;
